import apiClient from '../lib/axios';

export interface CustomerProfile {
  id: string;
  userId: string;
  fullName?: string;
  phoneNumber?: string;
  cedulaImageUrl?: string;
  insuranceCardImageUrl?: string;
  defaultDeliveryAddress?: string;
  isProfileComplete: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateCustomerProfileInput {
  fullName?: string;
  phoneNumber?: string;
  defaultDeliveryAddress?: string;
}

export async function getMyCustomerProfile(): Promise<CustomerProfile> {
  const { data } = await apiClient.get<CustomerProfile>('/customer-profile/me');
  return data;
}

export async function updateMyCustomerProfile(input: UpdateCustomerProfileInput): Promise<CustomerProfile> {
  const { data } = await apiClient.patch<CustomerProfile>('/customer-profile/me', input);
  return data;
}

export async function uploadMyDocument(
  type: 'CEDULA' | 'INSURANCE_CARD',
  file: File,
): Promise<{ url: string; type: string }> {
  const form = new FormData();
  form.append('type', type);
  form.append('file', file);
  const { data } = await apiClient.post('/customer-profile/me/documents', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function deleteMyDocument(
  type: 'CEDULA' | 'INSURANCE_CARD',
): Promise<{ message: string }> {
  const { data } = await apiClient.delete('/customer-profile/me/documents', {
    data: { type },
  });
  return data;
}
